import { store } from "../store";
import { API_CONFIG } from "./constants/constant";
import http from "./http.service";

const getsalaryAdvanceList = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "SALARY_ADV",
      requestId: "SALARY_AVD_LOAN_QUERY_INFO",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.getsalaryAdvanceList,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const salaryAdvanceLoanRequestVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      module: "SALARYADV",
      requestId: "SALARY_AVD_LOAN_REQ_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.salaryAdvanceLoanRequestVerify,
      reqParams
    );
    return {
      status: response.status,
      data: response.data["data"],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const salaryAdvanceLoanRequestConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      module: "SALARYADV",
      requestId: "SALARY_AVD_LOAN_REQ",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.salaryAdvanceLoanRequestConfirm,
      reqParams
    );
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const salaryAdvanceLoanRepayVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      module: "SALARYADV",
      requestId: "SALARY_AVD_LOAN_REPAY_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.salaryAdvanceLoanRepayVerify,
      reqParams
    );
    return {
      status: response.status,
      data: response.data["data"],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const salaryAdvanceLoanRepayConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      module: "SALARYADV",
      requestId: "SALARY_AVD_LOAN_REPAY_CONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.salaryAdvanceLoanRepayConfirm,
      reqParams
    );
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const SalaryAdvanceService = {
  getsalaryAdvanceList,
  salaryAdvanceLoanRequestVerify,
  salaryAdvanceLoanRequestConfirm,
  salaryAdvanceLoanRepayVerify,
  salaryAdvanceLoanRepayConfirm,
};

export default SalaryAdvanceService;
